function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterdelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.352,
    height: 101.252,
    viewBox: "0 0 97.352 101.252",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50909",
    d: "M48.429 16.345 45.962 0H9.776A9.808 9.808 0 0 0 0 9.888v68.428a9.732 9.732 0 0 0 9.776 9.8H44.1L68.832 50.67v-26.7zm0 0",
    style: {
      fill: "#4394ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50910",
    d: "m285.277.141 22.8 23.946H292.9a7.617 7.617 0 0 1-7.623-7.623zm0 0",
    transform: "translate(-239.315 -.118)",
    style: {
      fill: "#006cfc"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17403"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50911",
    d: "M86.852 323.16h29.214a2.242 2.242 0 1 0 0-4.484H86.852a2.242 2.242 0 1 0 0 4.484zm0 0",
    transform: "translate(-70.977 -267.333)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50912",
    d: "M86.852 253.582h22.712a2.242 2.242 0 1 0 0-4.484H86.852a2.242 2.242 0 1 0 0 4.484zm0 0",
    transform: "translate(-70.977 -208.965)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50913",
    d: "M108.689 389.648H86.852a2.242 2.242 0 1 0 0 4.484h21.837a2.242 2.242 0 1 0 0-4.484zm0 0",
    transform: "translate(-70.977 -326.871)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50914",
    d: "M257.183 285.292a28.507 28.507 0 1 1-3.991-.292 33.82 33.82 0 0 1 3.991.292zm0 0",
    transform: "translate(-184.426 -240.944)",
    style: {
      fill: "#00d2a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50915",
    d: "M303.637 343.578h-5.7v-1a3.069 3.069 0 0 0-3.028-3.028h-5.967a2.993 2.993 0 0 0-2.939 3.028v1h-5.772a1.492 1.492 0 0 0 0 2.983h1.73l1.6 18.064a1.467 1.467 0 0 0 1.491 1.328h13.768a1.479 1.479 0 0 0 1.491-1.328l1.6-18.064h1.731a1.492 1.492 0 0 0 0-2.983zm-14.648-1.044h5.967v1.044h-5.967zm8.458 20.436h-11.038l-1.448-16.408h13.947zm0 0",
    transform: "translate(-222.562 -279.494)",
    style: {
      fill: "#fff"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterdelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filterdelete.1aef7660aee4e008b71b4fa6f8f52a61.svg";